export default __webpack_public_path__ + "static/media/unknown.64936657.png";